function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './invoice-fapiao-request.scss';
import React, { useState } from 'react';
import FapiaoRequestForm from 'researcher/fapiao/components/FapiaoRequestForm';
import Redirect from 'shared/components/Redirect';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
var InvoiceFapiaoRequest = function InvoiceFapiaoRequest(_ref) {
  var _ref$invoice = _ref.invoice,
    _ref$invoice$customFi = _ref$invoice.customFields,
    _ref$invoice$customFi2 = _ref$invoice$customFi === void 0 ? {} : _ref$invoice$customFi,
    submission = _ref$invoice$customFi2.Submission,
    invoiceNumber = _ref$invoice.invoiceNumber,
    payment = _ref.payment,
    redirectUrl = _ref.redirectUrl,
    backLinkText = _ref.backLinkText,
    loadInvoices = _ref.loadInvoices,
    createFapiao = _ref.createFapiao,
    loadFapiaos = _ref.loadFapiaos;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var handleFapiaoCreation = function handleFapiaoCreation() {
    setRedirect(redirectUrl);
    loadInvoices();
  };
  if (redirect) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirect
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-75 p-0 container invoice-fapiao-request"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    bodyClassName: "bg-gray-lighter",
    title: "Create fapiao"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row text-small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Link, {
    to: redirectUrl,
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: "fa-solid fa-arrow-left"
  }), /*#__PURE__*/React.createElement(T, {
    source: backLinkText
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "pb-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Create Fapiao for order %s",
    params: submission || invoiceNumber || ''
  })))), /*#__PURE__*/React.createElement(FapiaoRequestForm, {
    receiptCode: invoiceNumber,
    payment: payment,
    onFapiaoCreated: handleFapiaoCreation,
    successRedirect: redirectUrl,
    createFapiao: createFapiao,
    loadFapiaos: loadFapiaos
  }));
};
export default InvoiceFapiaoRequest;